export class SupplierNetwork {
    constructor(
        public readonly id: number,
        public readonly name: string,
        public readonly cnpj: string,
        public readonly token: string
    ) {}

    get displayCNPJ(): string {
        const cleaned = this.cnpj.replace(/\D/g, '');
        if (cleaned.length !== 14) return this.cnpj;
        return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(5, 8)}/${cleaned.slice(8, 12)}-${cleaned.slice(12)}`;
    }

    get cleanCNPJ(): string {
        return this.cnpj.replace(/\D/g, '');
    }
}

